<template>
    <div>
        <div class="flex items-center h-screen justify-center">
            <div class="text-center grow">
                <h1 class="text-4xl font-bold">Oups..</h1>
                <div class="mt-2 text-xl font-light">{{ $tt('Cet espace est suspendu') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/companies/default/views/Blocked.vue